$(document).ready(function () {
  var $slider = $(".commmunity-slider");
  if ($slider.length && $slider.children().length > 0) {
    $slider.slick({
      slidesToShow: 6,
      slidesToScroll: 1,
      autoplaySpeed: 5000,
      autoplay: true,
      dots: false,
      arrows: false,
      infinite: true,
      centerMode: true,
      centerPadding: "6%",
      swipeToSlide: true,
      rtl: false, // Ensure not in RTL mode
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3.5,
            slidesToScroll: 1,
            swipeToSlide: true,
             centerMode: false,
             centerPadding: "0%",
          },
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 2.5,
            slidesToScroll: 1,
            infinite: false,
            autoplay: true,
             centerMode: false,
             centerPadding: "0%",
          },
        },
      ],
    });
  }
});
